import config from 'config'
import { fork, put, take } from 'redux-saga/effects'
import apiRequest from '../../common/apiRequest'
import NotificationType from 'app/redux-base/enums/NotificationType'
import { LOAD_WHITELABELS_LIST } from 'app/redux-base/actions/whitelabelsList'
import {
  showNotification,
  clearNotifications,
} from 'app/redux-base/actions/notifications'

export default function* loadWhitelabels(action = {}) {
  const { search, page } = action
  const url = `${config.BASE_URL_V2}/whitelabels/whitelabel/`
  const params = { page }
  if (search) {
    params.search = search
  }

  const apiCall = apiClient => apiClient.get(url, { params })

  yield fork(apiRequest, apiCall, LOAD_WHITELABELS_LIST, action)

  const resultAction = yield take([
    LOAD_WHITELABELS_LIST.SUCCESS,
    LOAD_WHITELABELS_LIST.FAILURE,
  ])

  if (resultAction.type === LOAD_WHITELABELS_LIST.FAILURE) {
    yield put(
      showNotification({
        type: NotificationType.ERROR,
        title: 'Loading whitelabels failed',
        message: resultAction.error,
      })
    )
  } else {
    yield put(clearNotifications())
  }
}
